module.exports = __webpack_public_path__ + "img/av247.2129ff13.png";